import { filterInt } from './int';

export const palletsValidator = value => {
    const response = {
        isValid: true,
        notification: { type: 'success', msg: '', title: '' },
    };

    if (!isNaN(filterInt(value)) || value === '') {
        // If value is empty then on deselect don't show the validator because we have custom validation
        if (parseInt(value, 10) > 999) {
            response.isValid = false;
            response.notification.type = 'error';
            response.notification.msg = 'Must be less than 1000!';
        }
    }
    return response;
};

export const impactedBoxesValidator = (value, row) => {
    const response = {
        isValid: true,
        notification: { type: 'success', msg: '', title: '' },
    };

    if (value === '') {
        return response;
    }

    if (isNaN(parseInt(value, 10))) {
        response.isValid = false;
        response.notification.type = 'error';
        response.notification.msg = 'Value must be a number.';
        return response;
    }

    if (value > row.totalNumberOfBoxes) {
        response.isValid = false;
        response.notification.type = 'error';
        response.notification.msg = `Value cannot be greater than ${row.totalNumberOfBoxes}.`;
        return response;
    }

    if (value <= 0) {
        response.isValid = false;
        response.notification.type = 'error';
        response.notification.msg = 'Value must be greater than 0.';
        return response;
    }

    return response;
};
